import { Component, Input, OnInit } from '@angular/core';
import { VColor } from '../../../modules/sanna/data/models/constants.interface';

@Component({
  selector: 'app-field-required',
  templateUrl: './field-required.component.html',
})
export class FieldRequiredComponent implements OnInit {
  /** Color del elemento. Variable por si la estética requiere que un elemento viaulmente no sea tan "impactante" (rojo) */
  @Input() color: VColor;

  constructor() {
    this.color = 'danger';
  }

  ngOnInit() {}
}
